import { Component, h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import { PostType, TopicTypes } from './Types'
import TopicRepliesEmptyStatus from './TopicRepliesEmptyStatus'
import TopicReply from './TopicReply'
import { LikedUserType } from './LikedUsers'
import Pagination from '../ui-components/Pagination'
import qs from 'qs'

interface Props {
  type: TopicTypes,
  currentUser: LikedUserType,
  topicId: number,
  topicAuthorId: number,
  replies: Array<PostType>,
  pinnedReplyId?: string | null,
  totalRepliesPageCount: number,
  currentRepliesPage: number,
  totalRepliesCount: number
}

interface State {}

class TopicReplies extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {}
  }

  generateNewUrl (newPage: number) {
    const regex = /\/index\d+\.html/
    const splittedUrl = window.location.pathname.replace(regex, '')
    const newPagination = newPage === 1 ? '' : `/index${newPage}.html`
    let searchQuery = window.location.search
    let queryParameters = qs.parse(searchQuery, { ignoreQueryPrefix: true })
    delete queryParameters?.postid
    return `${window.location.origin}${splittedUrl}${newPagination}${qs.stringify(queryParameters)}`
  }

  render ({ replies, topicId, topicAuthorId, currentUser, type, pinnedReplyId, totalRepliesPageCount, currentRepliesPage, totalRepliesCount }: Props) {
    return (
      <div className='box' id='comments'>
        <header className='list__items--header qa-topic-reply-box-header'>
          <h3 className='qa-total-replies'>
            <Phrase p={totalRepliesCount ? '{n} Reply|{n} Replies' : 'no.replies'} count={{ n: totalRepliesCount.toString() }} />
          </h3>
        </header>
        {
          replies.length ? (
            <div>
              {
                totalRepliesPageCount > 1 ? (
                  <Pagination totalPageCount={totalRepliesPageCount} currentPage={currentRepliesPage} generateNewUrl={this.generateNewUrl} />
                ) : null
              }
              {
                replies.map((reply: PostType, idx: number) => <TopicReply
                  currentUser={currentUser}
                  displayAuthor={reply.author.id === topicAuthorId}
                  topicId={topicId}
                  reply={reply}
                  type={type}
                  isLastItem={replies.length === idx + 1}
                  isPinned={String(reply.id) === String(pinnedReplyId)}
                />)
              }
            </div>
          ) : (
            <TopicRepliesEmptyStatus />
          )
        }
      </div>
    )
  }
}

export default TopicReplies
